import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {LOCALE_ID, NgModule} from '@angular/core';
import { FormsModule } from '@angular/forms';
import {HttpClientModule, HttpClient, HTTP_INTERCEPTORS} from '@angular/common/http';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AgmCoreModule } from '@agm/core';

import {
  MatSidenavModule,
  MatCardModule,
  MatMenuModule,
  MatCheckboxModule,
  MatIconModule,
  MatButtonModule,
  MatToolbarModule,
  MatTabsModule,
  MatListModule,
  MatSlideToggleModule,
  MatSelectModule,
  MatProgressBarModule,
  MatSnackBarModule,
  MatTooltipModule,
  MatProgressSpinnerModule,
  MAT_DATE_LOCALE,
  MatAutocompleteModule,
  MatDialogModule,
  MatInputModule,
  MatExpansionModule
} from '@angular/material';
import { FlexLayoutModule } from '@angular/flex-layout';
import {BidiModule} from '@angular/cdk/bidi';

import {AppRoutingModule} from './app.routing';
import { AppComponent } from './app.component';
import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { SharedModule } from './shared/shared.module';
import {AuthService} from './shared/auth/auth.service';
import {AuthGuard} from './shared/auth/auth-guard.service';
import {UserService} from './shared/user/user.service';
import {AuthInterceptorService} from './shared/auth/auth-interceptor.service';
import {SnackMessageComponent} from './shared/snack-messages/snack-message/snack-message.component';
import {SnackMessageService} from './shared/snack-messages/snack-message.service';

import { ProfileModule } from './profile/profile.module';
import {MediaService} from './shared/media/media.service';
import {CountryService} from './parameters/countries/country.service';
import {OrganizationService} from './organization/organization.service';
import {UsersPartnerService} from './users/users-partner/users-partner.service';
import {AgencyService} from './agency/agency.service';
import {CityService} from './parameters/cities/city.service';
import {UsersClkService} from './users/users-clk/users-clk.service';
import {RoleService} from './parameters/roles/role.service';
import {CallCenterService} from './call-center/call-center.service';
import {MonetaryAreaService} from './parameters/monetary-areas/monetary-area.service';
import {CustomerService} from './customer/customer.service';
import {ReportsResolver} from './report/reports/reports-resolver.service';
import {ReportsService} from './report/reports/reports.service';
import {DialogMessagesComponent} from './shared/dialog-messages/dialog-messages.component';
import {DialogMessageService} from './shared/dialog-messages/dialog-message.service';
import {Utils} from './shared/utils/Utils';
import {OperationService} from './operation/operations/operation.service';
import {ProfileService} from './profile/profile.service';
import {ChangePasswordDialogComponent} from './shared/change-password-dialog/change-password-dialog.component';
import {AppLoaderModule} from './app-loader/app-loader.module';
import { PlatformService } from './parameters/platforms/platform.service';
import { CommissionAccountService } from './commission-account/commission-account.service';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}


@NgModule({
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    AuthLayoutComponent,
    SnackMessageComponent,
  ],
  imports: [
    AppLoaderModule,
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    AppRoutingModule,
    FormsModule,
    ProfileModule,
    HttpClientModule,
    MatAutocompleteModule,
  MatButtonModule,
  MatCardModule,
  MatDialogModule,
  MatIconModule,
  MatInputModule,
  MatProgressSpinnerModule,
  MatSelectModule,
  MatTabsModule,
  MatTooltipModule,
  MatCheckboxModule,
  NgxDatatableModule,
  MatExpansionModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    MatSidenavModule,
    MatCardModule,
    MatCheckboxModule,
    MatMenuModule,
    MatCheckboxModule,
    MatIconModule,
    MatButtonModule,
    MatToolbarModule,
    MatTabsModule,
    MatListModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatProgressBarModule,
    MatSnackBarModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    FlexLayoutModule,
    BidiModule,
    AgmCoreModule.forRoot({apiKey: 'YOURAPIKEY'})
  ],
  providers: [
    AuthService,
    AuthGuard,
    UserService,
    SnackMessageService,
    DialogMessageService,
    ProfileService,
    MediaService,
    CountryService,
    PlatformService,
    CityService,
    OrganizationService,
    AgencyService,
    UsersPartnerService,
    UsersClkService,
    RoleService,
    MonetaryAreaService,
    CallCenterService,
    CustomerService,
    OperationService,
    ReportsService,
    CommissionAccountService,
    ReportsResolver,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    Utils,
    {provide: MAT_DATE_LOCALE, useValue: 'fr-FR'},
    {provide: LOCALE_ID, useValue: 'fr-FR'},
  ],
  entryComponents: [
    SnackMessageComponent,
    DialogMessagesComponent,
    ChangePasswordDialogComponent,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts